// UI-4: the phone top bar (addendum 3): the menu button, the page's name, the bell. 56px plus the
// notch; sticky, so the page flows beneath it rather than under a fixed bar with a padding guess.
import React from 'react';
import './shell.css';

export default function TopBar({ title, onMenu, menuOpen, bell }) {
  return (
    <header className="ui-topbar" data-testid="topbar">
      <button type="button" className="ui-topbar__menu" onClick={onMenu} aria-label="Open menu" aria-expanded={menuOpen} aria-haspopup="dialog">
        <span aria-hidden="true">☰</span>
      </button>
      <h1 className="ui-topbar__title">{title}</h1>
      {bell}
    </header>
  );
}
